import { Expose, Type } from 'class-transformer';
import { ViewContactDto } from '../../contacts/dto/view-contact.dto';
import { ViewBillingAddressDto } from './view-billing-address.dto';

export class ViewBillingAddressExtendedDto extends ViewBillingAddressDto {
  @Expose() @Type(() => ViewContactDto) contacts: ViewContactDto[];
}
